import Phaser from "phaser";
import type { PlayerState } from "../runtime/playerState";

export class BacklogView {
  private container: Phaser.GameObjects.Container;
  private resolver: (() => void) | null = null;
  private scrollOffset = 0;

  constructor(private scene: Phaser.Scene, private state: PlayerState) {
    this.container = scene.add.container(0, 0).setVisible(false).setDepth(100);
  }

  open(): Promise<void> {
    this.cleanup();
    const w = this.scene.scale.width;
    const h = this.scene.scale.height;

    const dim = this.scene.add.rectangle(w / 2, h / 2, w, h, 0x000000, 0.86);
    this.container.add(dim);

    const title = this.scene.add
      .text(40, 30, "バックログ", {
        fontFamily: "system-ui, sans-serif",
        fontSize: "26px",
        color: "#ffffff",
      })
      .setOrigin(0, 0);
    this.container.add(title);

    const close = this.scene.add
      .text(w - 40, 30, "閉じる ×", {
        fontFamily: "system-ui, sans-serif",
        fontSize: "18px",
        color: "#ffaaaa",
      })
      .setOrigin(1, 0)
      .setInteractive({ useHandCursor: true });
    close.on("pointerdown", () => this.resolveAndClose());
    this.container.add(close);

    // バックログ本体(直近 30 件)
    const entries = this.state.backlog.slice(-30);
    const top = 80;
    const lineH = 22;

    entries.forEach((entry, i) => {
      const y = top + i * (lineH + 14);
      const speakerStr = entry.speaker ? `${entry.speaker}:` : "(地の文)";
      const headerColor = entry.speaker ? "#ffd28a" : "#88ccff";

      const speaker = this.scene.add.text(40, y, speakerStr, {
        fontFamily: "system-ui, sans-serif",
        fontSize: "15px",
        color: headerColor,
      });

      const body = this.scene.add.text(40 + 130, y, entry.text, {
        fontFamily: "system-ui, sans-serif",
        fontSize: "15px",
        color: "#ffffff",
        wordWrap: { width: w - 200 },
      });
      this.container.add([speaker, body]);
    });

    if (entries.length === 0) {
      const empty = this.scene.add
        .text(w / 2, h / 2, "(履歴はまだありません)", {
          fontFamily: "system-ui, sans-serif",
          fontSize: "18px",
          color: "#888888",
        })
        .setOrigin(0.5);
      this.container.add(empty);
    }

    this.container.setVisible(true);
    return new Promise((resolve) => {
      this.resolver = resolve;
    });
  }

  private resolveAndClose(): void {
    const r = this.resolver;
    this.resolver = null;
    this.cleanup();
    this.container.setVisible(false);
    if (r) r();
  }

  private cleanup(): void {
    this.container.each((c: Phaser.GameObjects.GameObject) => c.destroy());
    this.container.removeAll(false);
  }

  setScrollOffset(n: number): void {
    this.scrollOffset = n;
  }
}
